import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import SidePanel from "./SidePanel";
import Users from "../tables/Users";
import Companies from "../tables/Companies";
import Organizations from "../tables/Organizations";
import PromoCodes from "../pages/PromoCodes";
import Rules from "../pages/Rules";
import General from "../pages/General";
import "../styles/Dashboard.css";
import Admin from "../tables/Admin";
import Models from "../tables/Models";

function Dashboard({ onLogout, userData }) {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [activeSection, setActiveSection] = useState("promocodes");
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  // Update active section based on URL
  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      setActiveSection("promocodes");
    } else if (path.startsWith("/companies")) {
      setActiveSection("companies");
    } else if (path.startsWith("/projects")) {
      setActiveSection("organizations");
    } else if (path.startsWith("/promocodes")) {
      setActiveSection("promocodes");
    } else if (path.startsWith("/users")) {
      setActiveSection("users");
    } else if (path.startsWith("/admin")) {
      setActiveSection("admin");
    } else if (path.startsWith("/models")) {
      setActiveSection("models");
    } else if (path.startsWith("/rules")) {
      setActiveSection("rules");
    } else if (path.startsWith("/general")) {
      setActiveSection("general");
    }
  }, [location.pathname]);

  // Handle mobile/desktop transitions
  useEffect(() => {
    if (isMobile) {
      // On mobile, always start with sidebar closed
      setSidebarOpen(false);
    } else {
      // On desktop, always show sidebar
      setSidebarOpen(true);
    }
  }, [isMobile]);

  const handleSectionChange = (section) => {
    setActiveSection(section);
    if (section === "promocodes") {
      navigate("/");
    } else if (section === "organizations") {
      navigate("/projects");
    } else {
      navigate(`/${section}`);
    }
  };

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const renderMainContent = () => {
    switch (activeSection) {
      case "promocodes":
        return <PromoCodes />;
      case "companies":
        return <Companies />;
      case "organizations":
        return <Organizations />;
      case "users":
        return <Users />;
      case "admin":
        return <Admin />;
      case "models":
        return <Models />;
      case "rules":
        return <Rules />;
      case "general":
        return <General />;
      default:
        return <PromoCodes />;
    }
  };

  return (
    <div className={`dashboard ${isMobile ? "mobile" : "desktop"}`}>
      <SidePanel
        activeSection={activeSection}
        onSectionChange={handleSectionChange}
        onLogout={onLogout}
        userData={userData}
        isMobile={isMobile}
        isOpen={sidebarOpen}
        onToggle={handleSidebarToggle}
      />
      <main className={`main-content ${isMobile ? "mobile" : "desktop"}`}>
        <div className="content-header">
          <h1>
            {activeSection === "organizations"
              ? "Projects"
              : activeSection.charAt(0).toUpperCase() + activeSection.slice(1)}
          </h1>
        </div>
        <div className="content-body">{renderMainContent()}</div>
      </main>
    </div>
  );
}

export default Dashboard;
